const loadingOpts = {
  except: [
    'activities/fetchFavorites',
    'activities/fetchRecentActivities',
    'activities/updateFavorite',
    'app/changeDateRange',
    'app/clearCaches',
    'app/config',
    'app/createDirectUpload',
    'app/createFileFromSignedId',
    'app/logout',
    'app/startQuestionnaire',
    'app/surveyQuestionnaire',
    'app/latestSurveyLinkByKind',
    'app/updateHealthData',
    'app/updateKetoMojoData',
    'courses/fetchCourses',
    'events/fetch',
    'dailyCharts/fetch',
    'dailyNutrition/fetch',
    'dailyNutrition/fetchNutrition',
    'insuranceStatus/runInsuranceBenefitsCheck',
    'marketplace/createProviderSetupIntent',
    'meals/fetchFavorites',
    'meals/fetchRecentMeals',
    'meals/updateFavorite',
    'sensor/updateStatus',
    'uiFlags/fetch',
    'users/fetch',
    'users/registerToken',
    'notifications/dismiss',
    'notifications/complete',
    'notifications/dismissLive',
    'notifications/completeLive',
    'nutritionistHub/fetchEhrEarlierAvailableSlots',
    'settings/generateTerraSdkToken',
    'policyConsents/statuses',
    'nutritionistHub/fetchMemberNotes',
  ],
}

export default loadingOpts
